import BasicLayout from "../components/BasicLayout";
import {Card, Grid, Select, InputAdornment, IconButton} from "@mui/material";
import MDBox from "../../Components/MDBox";
import {useFormik} from "formik";
import MDTypography from "../../Components/MDTypography";
import MDInput from "../../Components/MDInput";
import MDButton from "../../Components/MDButton";
import React, {useState} from "react";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import {UserModel} from "../../Api/Model/UserModel";
import * as yup from "yup";
import {toast} from "react-toastify";
import {PromiseToaast} from "../../utils/toast/Toast";
import {useNavigate} from "react-router-dom";
import ULogin from "../../utils/Hooks/ULogin";
import MDSelect from "../../Components/MDSelect";
import MDDate from "../../Components/MDDate";

const validationSchema = yup.object({
    name: yup
        .string()
        .required("نام را وارد کنید"),
    lastName: yup
        .string()
        .required("نام خانوادگی را وارد کنید"),
    codeMeli: yup
        .string()
        .required("کد ملی را وارد کنید")
        .matches(/^\d{10}$/, "کد ملی باید 10 رقم باشد"),
    birthday: yup
        .date()
        .required("تاریخ تولد را وارد کنید"),
    username: yup
        .string()
        .required("نام کاربری را وارد کنید"),
    phoneNumber: yup
        .string()
        .required("شماره تماس را وارد کنید")
        .matches(/^\d{10,11}$/, "شماره تماس باید 10 یا 11 رقم باشد"),
    password: yup
        .string()
        .required("رمز عبور را وارد کنید")
        .min(8, "رمز عبور باید حداقل 8 کاراکتر باشد"),
    repassword: yup
        .string()
        .oneOf([yup.ref('password'), null], "رمز عبور و تکرار آن باید یکسان باشند")
        .required("تکرار رمز عبور را وارد کنید"),
    role: yup
        .string()
        .required("نقش را انتخاب کنید"),
    nezampezeshki: yup.string().when('role', {
        is: '0',
        then:()=> yup.string().required("شماره نظام پزشکی را وارد کنید"),
    }),
    sex: yup.string().required("جنسیت الزامی است"),
    personliCode: yup.string().when('role', {
        is: '1',
        then:()=> yup.string().required("شماره پرسنلی را وارد کنید"),
    }),
 });
export default function RegisterPage() {
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    var model = new UserModel();
    const navigate = useNavigate();

    const formik = useFormik({
        onSubmit: (values) => {


            setLoading(true);
            model.Register({
                grant_type: "password",
                username: values.username,
                password: values.password,
                repassword: values.repassword,
                
                name: values.name,
                lastName: values.lastName,
                codeMeli: values.codeMeli,
                birthday: values.birthday,
                phoneNumber: values.phoneNumber,
                role: parseInt(values.role ?? "3"),
                nezampezeshki: values.nezampezeshki,
                personliCode: values.personliCode,
                sex: values.sex
            })
                .then(response => {
                     navigate("/login", {replace: true});
                })
                .catch(error => {
                    toast.error(error.message || "خطا در ثبت نام");
                    setLoading(false);
                });
        },
        initialValues: {
            name: "",
            lastName: "",
            codeMeli: "",
            birthday: "",
            username: "",
            phoneNumber: "",
            password: "",
            repassword: "",
            role: "",
            nezampezeshki: "",
            sex: "",
            personliCode: ""
        },
        validationSchema
    });
    return <BasicLayout image={require("../../Asset/images/bgze.png")}>

        <Grid container sx={{height: "100%"}} flexDirection={"row"}>
            <Grid item xs={12} md={4} sm={12} alignSelf={{xs: "center", md: "unset", sm: "center"}}
                  textAlign={"center"}>
                <MDBox sx={{position: "relative"}}>
                    <MDBox pt={4} pb={{xs: 0, md: 3, sm: 3}} component="form" role="form"
                           onSubmit={formik.handleSubmit}>
                        <Grid container direction={"column"} alignItems={"center"}>
                            <Grid item>
                                <MDBox px={10} bgColor={"rgba(255,255,255,0.02)"}>
                                    <MDTypography color={"inherit"} fontWeight={"bold"}
                                                  sx={{
                                                      color: "rgb(52,39,9)", textShadow: "1px 0px 15px #fff",
                                                      fontSize: {xs: 30, md: 40, sm: 30}
                                                  }}>ثبت نام در سامانه قهرمان سلامت</MDTypography>
                                </MDBox>
                            </Grid>
                        </Grid>
                    </MDBox>
                </MDBox>
            </Grid>
            <Grid item xs={12} md={8} sm={12}>
                <MDBox sx={{position: "relative"}} mt={{xs: "0rem", md: "10rem", sm: "0rem",}}>
                    <MDBox pt={{xs: 0, md: 4, sm: 4}} pb={3} component="form" role="form"
                           onSubmit={formik.handleSubmit}>
                        <Grid container item rowSpacing={"2rem"} textAlign={"center"}>
                            <Grid item xs={6}>
                                <MDInput
                                    id="name"
                                    name="name"
                                    value={formik.values.name}
                                    onChange={formik.handleChange}
                                    error={
                                        formik.touched.name && Boolean(formik.errors.name)
                                    }
                                    helperText={formik.touched.name && formik.errors.name}
                                    autoComplete={"name"}
                                    disabled={loading}

                                    sx={{width: {xs: "90%", md: "80%", sm: "80%",}}}
                                    label={"نام"}/>
                            </Grid>
                            <Grid item xs={6}>
                                <MDInput
                                    id="lastName"
                                    name="lastName"
                                    value={formik.values.lastName}
                                    onChange={formik.handleChange}
                                    error={
                                        formik.touched.lastName && Boolean(formik.errors.lastName)
                                    }
                                    helperText={formik.touched.lastName && formik.errors.lastName}
                                    autoComplete={"lastName"}
                                    disabled={loading}
                                    fullWidth
                                    sx={{width: {xs: "90%", md: "80%", sm: "80%",}}}
                                    label={"نام خانوادگی"}/>
                            </Grid>
                            <Grid item xs={6}>
                                <MDSelect
                                    id="sex"
                                    name="sex"
                                    value={formik.values.sex}
                                    onChange={(r) => formik.setFieldValue("sex", r)}
                                    error={
                                        Boolean(formik.errors.sex)
                                    }
                                    helperText={formik.errors.sex}
                                    autoComplete={"1"}
                                    disabled={loading}
                                    w={{xs: "90%", md: "80%", lg: "80%",}}
                                    label={"جنسیت"}>
                                    <option value={"زن"}>زن</option>
                                    <option value={"مرد"}>مرد</option>
                                    
                                </MDSelect>
                            </Grid>
                            <Grid item xs={6}>
                                <MDInput

                                    id="codeMeli"
                                    name="codeMeli"
                                    value={formik.values.codeMeli}
                                    onChange={formik.handleChange}
                                    error={
                                        formik.touched.codeMeli && Boolean(formik.errors.codeMeli)
                                    }
                                    helperText={formik.touched.codeMeli && formik.errors.codeMeli}
                                    autoComplete={"codeMeli"}
                                    disabled={loading}
                                    fullWidth
                                    sx={{width: {xs: "90%", md: "80%", sm: "80%",}}}
                                    label={"کد ملی"}/>
                            </Grid>
                            <Grid item xs={6}>
                                <MDDate
                                    name="birthday"
                                    onChange={(r) =>
                                        formik.setFieldValue("birthday", r)
                                    }
                                    defaultValue={formik.values.birthday}
                                    label={("تاریخ تولد")}
                                    error={
                                        Boolean(formik.errors.birthday)
                                    }
                                    portal
                                    helperText={
                                        formik.errors.birthday
                                    }
                                    w={{xs: "100%", md: "80%", lg: "80%",}}

                                    disabled={loading}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <MDInput

                                    id="username"
                                    name="username"
                                    value={formik.values.username}
                                    onChange={formik.handleChange}
                                    error={
                                        formik.touched.username && Boolean(formik.errors.username)
                                    }
                                    helperText={formik.touched.username && formik.errors.username}
                                    autoComplete={"username"}
                                    disabled={loading}
                                    fullWidth
                                    sx={{width: {xs: "90%", md: "80%", sm: "80%",}}}
                                    label={"نام کاربری"}/>
                            </Grid>
                            <Grid item xs={6}>
                                <MDInput

                                    id="phoneNumber"
                                    name="phoneNumber"
                                    value={formik.values.phoneNumber}
                                    onChange={formik.handleChange}
                                    error={
                                        formik.touched.phoneNumber && Boolean(formik.errors.phoneNumber)
                                    }
                                    helperText={formik.touched.phoneNumber && formik.errors.phoneNumber}
                                    autoComplete={"phoneNumber"}
                                    disabled={loading}
                                    fullWidth
                                    sx={{width: {xs: "90%", md: "80%", sm: "80%",}}}
                                    label={"شماره تماس"}/>
                            </Grid>
                            <Grid item xs={6}>
                                <MDInput

                                    id="password"
                                    name="password"
                                    type={showPassword ? "text" : "password"}
                                    value={formik.values.password}
                                    onChange={formik.handleChange}
                                    error={
                                        formik.touched.password && Boolean(formik.errors.password)
                                    }
                                    helperText={formik.touched.password && formik.errors.password}
                                    autoComplete={"password"}
                                    disabled={loading}
                                    fullWidth
                                    sx={{width: {xs: "90%", md: "80%", sm: "80%",}}}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    onClick={() => setShowPassword(!showPassword)}
                                                    onMouseDown={(e) => e.preventDefault()}
                                                    edge="end"
                                                >
                                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                                </IconButton>
                                            </InputAdornment>
                                        )
                                    }}
                                    label={"رمز عبور"}/>
                            </Grid>

                            <Grid item xs={6}>

                                <MDInput

                                    id="repassword"
                                    name="repassword"
                                    type={showPassword ? "text" : "password"}
                                    value={formik.values.repassword}
                                    onChange={formik.handleChange}
                                    error={
                                        formik.touched.repassword && Boolean(formik.errors.repassword)
                                    }
                                    helperText={formik.touched.repassword && formik.errors.repassword}
                                    autoComplete={"repassword"}
                                    disabled={loading}
                                    fullWidth
                                    sx={{width: {xs: "90%", md: "80%", sm: "80%",}}}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    onClick={() => setShowPassword(!showPassword)}
                                                    onMouseDown={(e) => e.preventDefault()}
                                                    edge="end"
                                                >
                                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                                </IconButton>
                                            </InputAdornment>
                                        )
                                    }}
                                    label={"تکرار رمز عبور"}/>
                            </Grid>
                            <Grid item xs={6}>
                                <MDSelect
                                    id="role"
                                    name="role"
                                    value={formik.values.role}
                                    onChange={(r) => formik.setFieldValue("role", r)}
                                    error={
                                        Boolean(formik.errors.role)
                                    }
                                    helperText={formik.errors.role}
                                    autoComplete={"1"}
                                    disabled={loading}
                                    w={{xs: "100%", md: "80%", sm: "80%"}}

                                    label={"نقش"}>
                                    <option value={0}>پزشک</option>
                                    <option value={1}>مربی</option>
                                    <option value={2}>والدین</option>
                                    <option value={3}>دآنش آموز</option>


                                </MDSelect>
                            </Grid>
                            <Grid item xs={6}>
                                {formik.values.role === "0" &&
                                    (
                                        <MDInput

                                            id="nezampezeshki"
                                            name="nezampezeshki"
                                            value={formik.values.nezampezeshki}
                                            onChange={formik.handleChange}
                                            error={
                                                formik.touched.nezampezeshki && Boolean(formik.errors.nezampezeshki)
                                            }
                                            helperText={formik.touched.nezampezeshki && formik.errors.nezampezeshki}
                                            autoComplete={"nezampezeshki"}
                                            disabled={loading}
                                            fullWidth
                                            sx={{width: {xs: "90%", md: "80%", sm: "80%",}}}
                                            label={"شماره نظام پزشکی"}/>
                                    )}

                                {formik.values.role === "1" && (
                                    <MDInput

                                        id="personliCode"
                                        name="personliCode"
                                        value={formik.values.personliCode}
                                        onChange={formik.handleChange}
                                        error={
                                            formik.touched.personliCode && Boolean(formik.errors.personliCode)
                                        }
                                        helperText={formik.touched.personliCode && formik.errors.personliCode}
                                        autoComplete={"personliCode"}
                                        disabled={loading}
                                        fullWidth
                                        sx={{width: {xs: "90%", md: "80%", sm: "80%",}}}
                                        label={"کد پرسنلی"}/>
                                )
                                }
                            </Grid>
                        </Grid>

                        <MDBox mt={12} mb={1} textAlign={"center"}>
                            <MDButton variant="gradient"
                                      sx={{
                                          background: "#01458D",
                                          width: {xs: "90%", md: "50%", sm: "50%"},
                                          fontSize: "1.2rem",
                                          height: "60px"
                                      }}

                                      type="submit"
                                      disabled={loading}
                                      fullWidth>
                                ثبت نام
                            </MDButton>
                        </MDBox>
                    </MDBox>
                </MDBox>
            </Grid>

        </Grid>

    </BasicLayout>
}